<template>
  <div class="cutdetletop">
    <div class="dqztbt">离婚后探视权是这么规定的？</div>
    <div class="dqztinfo flex_start">
      <div class="fm">
        <img src="../../../assets/zx_consult/consult_cover_sample.png" alt="" />
      </div>
      <div>
        <div class="dqztnr">
          <span>话题介绍：</span
          >探望权，又称见面交往权，是指离婚后不直接抚养子女的父亲或
          母亲一方享有的与未成年子女探望、联系、会面、交往、短期共同生活的权
          利。探望权从法理上看，是基于亲权的一种派生权利，只要身份关系存在，
          探望权就应该是非直接抚养一方的权利。
        </div>
        <div class="nrdbbq flex_end">
          <div>探视权</div>
          <div>2020.04.30 16:12</div>
          <div class="flex_start">
            <img src="../../../assets/base/kan.png" alt="" /> 123456 观看
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.cutdetletop {
  width: 100%;
  padding: 30px;
  .dqztbt {
    font-size: 30px;
    color: #333333;
  }
  .dqztinfo {
    align-items: flex-start;
    margin-top: 30px;
    .fm {
      margin-right: 20px;
      img {
        width: 240px;
        height: 160px;
      }
    }
    .dqztnr {
      font-size: 16px;
      color: #666;
      line-height: 22px;
      height: 130px;
      span {
        color: #ccc;
      }
    }
    .nrdbbq {
      font-size: 14px;
      color: #bbbbbb;
      >div{
          margin-left: 30px;
      }
      img{
          margin-right: 6px;
      }
    }
  }
}
</style>